<template>
  <div class="events-container">
    <headingComp :heading="'Eventos e Actividades'" :icon="require('@/assets/ic-white-eventos-actividades.svg')" :backgroundImage="require('@/assets/fg-antes-10@3x.jpg')" :scroll="false"/>
    <section class="agenda" v-if="agenda && agenda.length">
      <h1>Agenda</h1>
      <section class="scroll-down">
        <p>Scroll down</p>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <g fill="none" fill-rule="nonzero">
            <path d="M0 0h24v24H0z"/>
            <path fill="#f6b92f" d="M13 0v19.918L22.538 10 24 11.52 13 22.958V23h-.04L12 24l-.962-1H11v-.04L0 11.52 1.462 10 11 19.92V0h2z"/>
          </g>
        </svg>
      </section>
      <div class="agenda-container">
        <router-link :to="'/evento/' + agendaItem.id" class="agenda-item" :style="{left: `${leftItem * (key - currentAgendaItem)}%`}" v-for="(agendaItem, key) in agenda" :key="key">
          <img class="image" v-if="agendaItem.images.length" :src="agendaItem.images[0].image_url">
          <div class="text-content">
            <h4 v-if="agendaItem.translation">{{agendaItem.translation.name}}</h4>
            <p class="type" v-if="agendaItem.translation">{{agendaItem.translation.type}}</p>
            <p v-if="agendaItem.translation">{{agendaItem.translation.description}}</p>
            
            <div class="dates">
              <p>{{getDate(agendaItem.start_date)}}- {{getDate(agendaItem.end_date)}}</p>
            </div>

          </div>
        </router-link>
      </div>
      <div class="carousel-arrows">
        <div class="carousel-arrow left" v-if="currentAgendaItem !== 0" @click="currentAgendaItem--">
          <svg style="transform: rotate(180deg);" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <g fill="none">
              <path fill="#f6b92f" d="M13 0v19.918L22.538 10 24 11.52 13 22.958V23h-.04L12 24l-.962-1H11v-.04L0 11.52 1.462 10 11 19.92V0h2z" transform="rotate(-90 12 12)"/>
            </g>
          </svg>
        </div>
        <div class="carousel-arrow right" v-if="currentAgendaItem !== agenda.length - 1" @click="currentAgendaItem++">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <g fill="none">
              <path fill="#f6b92f" d="M13 0v19.918L22.538 10 24 11.52 13 22.958V23h-.04L12 24l-.962-1H11v-.04L0 11.52 1.462 10 11 19.92V0h2z" transform="rotate(-90 12 12)"/>
            </g>
          </svg>
        </div>
      </div>
      <div class="carousel-dots">
        <div class="carousel-dot" :class="{'active': index - 1 === Math.floor(currentAgendaItem / 3)}" v-for="index in Math.ceil(agenda.length / 3)" :key="index"
         @click="currentAgendaItem = (index - 1) * 3"
        >
          
        </div>
      </div>
    </section>
    <section class="o-que-fazer">
      <h1>O que fazer</h1>
      <div class="actividade-container">
        <article class="actividade" v-for="(activity, key) in activities" :key="key">
          <img class="image" :src="activity.images[0].image_url" v-if="activity.images[0]">
          <h4>{{activity.translation.name}}</h4>
          <p>{{activity.translation.description}}</p>
        </article>
      </div>
    </section>
  </div>
</template>
<script>

export default {
  name: 'eventosActividade',
  props: [],
  components: {
  },
  data() {
    return {
      agenda: null,
      currentAgendaItem: 3,
      activities: null,
      leftItem: 33.3
    }
  },
  async mounted () {
    this.agenda = await this.api.get('calendar')
    this.activities = await this.api.get('activity')

    this.$nextTick(function() {
      window.addEventListener('resize', this.getWindowWidth);
    })

    this.getWindowWidth()
  },
  methods: {
    getDate (date) {
      date = new Date(date)
      return date.getDate().toString().padStart(2, 0) + ' ' + this.getMonthName(date.getMonth()) + '. ' + date.getFullYear()
    },
    getMonthName (month) {
      return ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'][month]
    },
    getWindowWidth() {
      const width = document.documentElement.clientWidth
      console.log(width)
      if(width <= 1000 && width > 650){
        this.leftItem = 50;
      } else if (width <= 650){
        this.leftItem = 100;
      } else {
        this.leftItem = 33.33
      }
      return document.documentElement.clientWidth;
		}
  },
  destroyed(){
    this.$nextTick(function() {
      window.addEventListener('resize', this.getWindowWidth);
    })
  }
}
</script>
<style lang="scss" scoped>

.events-container {
  overflow: hidden;
}
h1 {
  font-size: 80px;
  display: table;
}
h2 {
  font-weight: bold;
  font-size: 36px;
  line-height: 40px;
}
.agenda {
  width: 90%;
  padding: 0 0 45px 0;
  margin: -100px auto;
  z-index: 5;
  position: relative;
  background: #f6ede0;
  h1 {
    margin: 0 auto;
    font-size: 64px;
    font-weight: bold;
    padding: 50px 0 50px 0;
    color: #f6b92f;
    text-transform: uppercase;

    @media (max-width: 650px){
      font-size: 32px;
      padding: 50px 0 20px;
    }
  }
  .agenda-container {
    margin: 0 10% 0 10%;
    width: 80%;
    position: relative;
    overflow: hidden;
    height: 360px;
    .agenda-item {
      width: calc(100% / 3 - 30px);
      margin: 0 15px;
      left: 0;
      position: absolute;
      transition: all 0.5s;
      .image {
        width: 100%;
        height: 215px;
        background: rgba(255, 255, 255, 0.3);
        display: block;
        object-fit: cover;
      }
      .text-content {
        position: relative;
        width: 100%;
      }
      h4 {
        padding: 20px 0 10px 0;
        font-size: 18px;
        font-weight: bold;
        color: #a79374;
      }
      .type {
        margin: 0 0 10px 0;
        color: #a79374;
        font-size: 16px;
        font-weight: bold;
      }
      .dates {
        top: -56px;
        position: absolute;
        width: 100%;
        background: rgba(223, 207, 182, 0.75);
        p {
          padding: 20px;
          font-size: 18px;
          font-weight: bold;
          color: #79762e;
        }
      }
    }

    @media (max-width: 1000px){
      .agenda-item {
        width: calc(100% / 2 - 30px);
      }
    }
    @media (max-width: 650px){
      .agenda-item {
        width: calc(100% - 30px);
      }
    }
  }

  @media (max-width: 700px){
    margin-top: 0;
    width: 100%;
  }
}
.o-que-fazer {  
  margin: 160px 0 40px 0;
  h1 {
    margin: 0 auto;
    font-size: 64px;
    letter-spacing: -2px;
    color: #f6b92f;
    text-transform: uppercase;
    font-weight: bold;
  }

  @media (max-width: 650px){
    h1 {
      font-size: 32px;
    }
  }
}
.actividade-container {
  margin: 10px 10% 150px 10%;
  display: flex;
  flex-wrap: wrap;
  .actividade {
    width: calc((100% / 3) - 30px);
    margin: 30px 15px;
    .image {
      width: 100%;
      height: 250px;
      background: rgba(0, 0, 0, 0.1);
      object-fit: cover;
    }
    h4 {
      margin: 20px 0;
      font-size: 24px;
      color: #a79374;
      line-height: 1.17;
      letter-spacing: -0.55px;
    }
    p {
      font-size: 18px;
      line-height: 1.56;
      letter-spacing: -0.4px
    }
  }

  @media (max-width: 650px){
    .actividade {
      width: 100%;
    }
  }
}
.carousel-arrows {
  .carousel-arrow {
    position: absolute;
    top: 50%;
    cursor: pointer;
    &.left {
      left: 50px;
    }
    &.right {
      right: 50px;
    }

    @media (max-width: 750px){
      transform: translateY(-250%);
      top: 50%;
      &.left {
        left: 30px;
      }
      &.right {
        right: 30px;
      }
    }

     @media (max-width: 600px){
       transform: translateY(-250%);
       top: 50%;
      &.left {
        left: 10px;
      }
      &.right {
        right: 10px;
      }
    }
  }
}
.carousel-dots {
  display: flex;
  width: fit-content;
  margin: 0 auto 0 auto;
  .carousel-dot {
    width: 10px;
    height: 10px;
    background: #f6b92f;
    border-radius: 50%;
    opacity: 0.4;
    margin: 7px;
    cursor: pointer;
    &.active {
      width: 24px;
      height: 24px;
      opacity: 1;
      margin: 0px;
    }
  }

  @media (max-width: 700px){
    margin-top: 30px;
  }
}
.scroll-down {
  color: #f6b92f;
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  position: absolute;
  right: 5%;
  top: 5%;
  p {
    text-transform: uppercase;
    font-size: 14px;
    font-weight: 800;
    letter-spacing: 1px;
  }
  svg {
    margin-left: 16px;
  }
}
</style>